import React from "react";

interface ViewOnlyNoticeProps {
  title: string;
  description: string;
}
export const ViewOnlyNotice: React.FC<ViewOnlyNoticeProps> = ({
  title,
  description,
}) => (
  <div
    className="mb-6 rounded-[1.5rem] border-4 border-[#F59E0B]/50 bg-[#FFFBEB] p-4 text-center shadow-[0_6px_0_#D97706]/35 sm:p-5"
    role="status"
  >
    <p className="text-sm font-extrabold text-[#92400E] sm:text-base">
      {description}
    </p>
  </div>
);
